import produce from 'immer';
import _ from 'lodash';

import {
  CLEAR_FORM_SUBMISSION_DETAIL,
  GET_FORM_SUBMISSION_DETAIL_FAILURE,
  GET_FORM_SUBMISSION_DETAIL_IN_PROGRESS,
  GET_FORM_SUBMISSION_DETAIL_SUCCESS
} from './formSubmissionTypes';

import { LOGOUT } from '../../auth/authReducer';

const initialState = {
  detail: {},
  loadingDetail: false
};

// eslint-disable-next-line default-param-last
const formSubmissionReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, ...payload } = action;

    switch (type) {
      case GET_FORM_SUBMISSION_DETAIL_IN_PROGRESS:
        draft.loadingDetail = true;
        break;
      case GET_FORM_SUBMISSION_DETAIL_SUCCESS:
        const formSubmission = _.getNonEmpty(payload, 'response.data', {});

        draft.detail = formSubmission;
        draft.loadingDetail = false;
        break;
      case GET_FORM_SUBMISSION_DETAIL_FAILURE:
        draft.loadingDetail = false;
        break;
      case CLEAR_FORM_SUBMISSION_DETAIL:
        draft.detail = initialState.detail;
        break;
      case LOGOUT:
        return initialState;
      default:
    }
  });

export default formSubmissionReducer;
